module.exports = __webpack_public_path__ + "img/controlesimg7Preservacao.5a29fcbb.svg";